import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/system';
import style from './submit.module.scss';
import omit from 'lodash-es/omit';
import cx from 'classnames';
import CircularLoader from 'components/loader/circular';

export default function Submit(
  props: ButtonProps & {
    wrapper?: {
      className?: string;
      loading?: boolean;
    };
    gradiented?: boolean;
  }
) {
  const loading = props?.wrapper?.loading || false;

  if (props.gradiented) {
    const Gradiented = styled(Button)(({ theme }) => ({
      background: `linear-gradient(95.35deg, ${theme.palette.primary.main} 12.04%, ${theme.palette.gradient_end} 204.31%)`,
    })) as typeof Button;

    return (
      <div
        className={cx(
          style.container,
          props?.wrapper?.className,
          'submit-container'
        )}
      >
        <Gradiented
          variant="contained"
          type="submit"
          color="primary"
          {...omit(props, ['wrapper', 'gradiented'])}
        ></Gradiented>
        {loading && <CircularLoader />}
      </div>
    );
  } else {
    return (
      <div
        className={cx(
          style.container,
          props?.wrapper?.className,
          'submit-container'
        )}
      >
        <Button
          variant="contained"
          type="submit"
          color="primary"
          {...omit(props, 'wrapper')}
        ></Button>
        {loading && <CircularLoader />}
      </div>
    );
  }
}
